import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceatmumbaiinternatinal() {



    const cardData = {

keyword: "Taxi Service at Mumbai International Airport",

headingDescription:
    "Mumbai Airport Cab offers fast, reliable, and affordable Taxi Service at Mumbai International Airport (BOM) for domestic and international passengers. We provide 24x7 airport pickup and drop services with real-time flight tracking, ensuring on-time arrival and stress-free transfers. Our fleet includes Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and verified chauffeurs. With doorstep pickup, transparent pricing, instant booking support, and comfortable rides, we ensure a smooth and safe airport travel experience across Mumbai and long-distance destinations.",

topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is a major IT and educational hub near Mumbai, frequently booked for airport pickups and drop transfers. It is one of the most common outstation routes for business and family travelers."
    },
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are popular hill stations known for scenic views, waterfalls, and weekend getaways. Many travelers book airport taxis directly for a comfortable trip from Mumbai Airport."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a spiritual and wine tourism destination known for Trimbakeshwar Temple and vineyards. It is a frequently booked outstation route from Mumbai Airport for pilgrims and tourists."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of the most important pilgrimage destinations in India. Airport taxi services are widely used for Sai Baba darshan trips directly from Mumbai Airport."
    },
    {
        title: "Goa",
        description:
            "Goa is India’s top holiday destination known for beaches, nightlife, and resorts. Many travelers prefer airport taxi services for long-distance comfortable road journeys from Mumbai."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a scenic hill station famous for strawberries, viewpoints, and cool weather. It is a popular weekend destination booked directly from Mumbai Airport."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a coastal beach destination near Mumbai known for clean beaches and resorts. It is ideal for short vacations and direct airport taxi transfers."
    },
    {
        title: "Igatpuri",
        description:
            "Igatpuri is a peaceful hill station surrounded by mountains and waterfalls. It is a popular monsoon and weekend getaway destination from Mumbai Airport."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is a historical city known for Ajanta and Ellora caves. It is a long-distance cultural and heritage trip often booked via airport taxis."
    },
    {
        title: "Daman & Diu",
        description:
            "Daman and Diu are coastal destinations known for beaches and Portuguese heritage. They are popular budget-friendly weekend trips from Mumbai Airport."
    }
],



services: [
{
name: "Taxi Service at Mumbai International Airport",
description: "Mumbai Airport Cab provides Taxi Service at Mumbai International Airport with reliable, safe, and comfortable transportation for arrivals and departures. We offer AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, and luxury vehicles with professional chauffeurs, flight tracking, luggage assistance, and 24x7 availability for smooth airport transfers across Mumbai and nearby cities."
},
{
name: "Mumbai Airport Taxi Service",
description: "Mumbai Airport Taxi Service ensures timely pickup and drop for domestic and international terminals with clean vehicles, experienced drivers, and hassle-free travel experience."
},
{
name: "Mumbai International Airport Cab Service",
description: "Mumbai International Airport Cab Service provides comfortable and safe airport transportation with verified chauffeurs, real-time flight tracking, and smooth ride experience."
},
{
name: "Airport Pickup Mumbai Cab",
description: "Airport Pickup Mumbai Cab offers quick and reliable pickup from Mumbai Airport terminals with doorstep assistance, luggage support, and professional drivers."
},
{
name: "Airport Drop Mumbai Taxi",
description: "Airport Drop Mumbai Taxi ensures punctual drop services to Mumbai International Airport with comfortable vehicles and stress-free travel for all passengers."
},
{
name: "Mumbai T2 Airport Cab Service",
description: "Mumbai T2 Airport Cab Service provides dedicated pickup and drop from Terminal 2 with fast response, clean vehicles, and trained chauffeurs."
},
{
name: "Mumbai Domestic Airport Taxi Service",
description: "Mumbai Domestic Airport Taxi Service offers reliable transfers from domestic terminals with safe driving, timely arrival, and comfortable travel experience."
},
{
name: "Mumbai International Airport Transfer Cab",
description: "Mumbai International Airport Transfer Cab ensures smooth intercity and local airport transfers with professional drivers and well-maintained vehicles."
},
{
name: "Mumbai Airport Car Hire Service",
description: "Mumbai Airport Car Hire Service provides chauffeur-driven vehicles for airport travel, corporate transfers, and family trips with flexible booking options."
},
{
name: "24x7 Mumbai Airport Taxi",
description: "24x7 Mumbai Airport Taxi offers round-the-clock availability for arrivals and departures, ensuring safe and reliable travel at any time of day or night."
},
{
name: "Fast Airport Cab Mumbai",
description: "Fast Airport Cab Mumbai ensures quick vehicle allocation and minimal waiting time for passengers needing urgent airport transportation."
},
{
name: "Mumbai Airport Ride Service",
description: "Mumbai Airport Ride Service provides on-demand cab booking with real-time tracking and smooth travel experience to and from airport terminals."
},
{
name: "Mumbai Airport Outstation Cab",
description: "Mumbai Airport Outstation Cab offers long-distance travel from airport to cities like Pune, Nashik, Goa, Shirdi, and more with comfortable vehicles."
},
{
name: "Mumbai Airport Premium Taxi Service",
description: "Mumbai Airport Premium Taxi Service provides luxury vehicles and executive chauffeur service for VIP passengers and business travelers."
},
{
name: "Mumbai Airport Family Cab Service",
description: "Mumbai Airport Family Cab Service ensures spacious and safe vehicles for families with luggage-friendly rides and comfortable seating."
},
{
name: "Mumbai Airport Business Cab Service",
description: "Mumbai Airport Business Cab Service offers professional transportation for corporate clients with punctual service and premium comfort."
},
{
name: "Mumbai Airport Booking Taxi",
description: "Mumbai Airport Booking Taxi allows easy pre-booking and instant confirmation with transparent pricing and reliable service support."
},
{
name: "Mumbai Airport Express Cab",
description: "Mumbai Airport Express Cab ensures fast pickup and drop service with minimal waiting time and efficient route management."
},
{
name: "Mumbai Airport Reliable Taxi Service",
description: "Mumbai Airport Reliable Taxi Service guarantees safe travel with verified drivers, GPS tracking, and consistent on-time performance."
},
{
name: "Mumbai Airport Transport Service",
description: "Mumbai Airport Transport Service provides complete travel solutions for airport transfers, city rides, and intercity journeys with comfort and safety."
}
],

tableData: [
["Taxi Service at Mumbai International Airport","Mumbai Airport Taxi Service"],
["Mumbai International Airport Cab Service","Airport Pickup Mumbai Cab"],
["Airport Drop Mumbai Taxi","Mumbai T2 Airport Cab Service"],
["Mumbai Domestic Airport Taxi Service","Mumbai International Airport Transfer Cab"],
["Mumbai Airport Car Hire Service","24x7 Mumbai Airport Taxi"],
["Fast Airport Cab Mumbai","Mumbai Airport Ride Service"],
["Mumbai Airport Outstation Cab","Mumbai Airport Premium Taxi Service"],
["Mumbai Airport Family Cab Service","Mumbai Airport Business Cab Service"],
["Mumbai Airport Booking Taxi","Mumbai Airport Express Cab"],
["Mumbai Airport Reliable Taxi Service","Mumbai Airport Transport Service"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Taxi Service at Mumbai International Airport",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable taxi services at Mumbai International Airport for arrivals, departures, corporate travel, family trips, and outstation journeys."
    },
    {
        WhyChooseheading: "24x7 Airport Pickup and Drop Facility",
        WhyChoosedescription: "Our airport taxi service operates round the clock, ensuring convenient transportation regardless of your flight arrival or departure time."
    },
    {
        WhyChooseheading: "Direct Transfers to Any Destination",
        WhyChoosedescription: "Whether you need transportation to Mumbai city, Navi Mumbai, Thane, Pune, Nashik, Shirdi, or any other destination, we provide seamless airport transfers."
    },
    {
        WhyChooseheading: "Wide Range of Airport Taxi Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "Flight Monitoring and Timely Pickup",
        WhyChoosedescription: "Our team tracks flight schedules to ensure timely pickups even if your flight is delayed or arrives earlier than expected."
    },
    {
        WhyChooseheading: "Professional Airport Chauffeurs",
        WhyChoosedescription: "Experienced drivers are familiar with airport procedures, pickup points, terminal access, and major travel routes across Mumbai."
    },
    {
        WhyChooseheading: "Ideal for Business and Leisure Travelers",
        WhyChoosedescription: "From corporate executives and international visitors to families and tourists, we provide comfortable airport transportation for every traveler."
    },
    {
        WhyChooseheading: "Safe, Comfortable, and Hassle-Free Travel",
        WhyChoosedescription: "Our well-maintained vehicles and professional service ensure a smooth travel experience from Mumbai International Airport to your destination."
    }
]
};

const faqData = [
    {
        question: "Do you provide taxi service at Mumbai International Airport?",
        answer: "Yes, Mumbai Airport Cabs offers airport pickup and drop services from Mumbai International Airport for local and outstation destinations."
    },
    {
        question: "Can I book an airport taxi in advance?",
        answer: "Yes, advance booking is recommended to ensure vehicle availability and smooth airport transfers."
    },
    {
        question: "Which vehicles are available for airport transfers?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
    },
    {
        question: "Do you provide airport transfers to Pune and other cities?",
        answer: "Yes, airport taxi services are available for Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Ahmedabad, and many other destinations."
    },
    {
        question: "Will the driver wait if my flight is delayed?",
        answer: "Yes, flight schedules are monitored to coordinate pickups according to the actual arrival time."
    },
    {
        question: "Can corporate travelers use airport taxi services regularly?",
        answer: "Yes, many business travelers and corporate clients use our airport transportation services for regular travel."
    },
    {
        question: "Are Tempo Travellers available for group airport transfers?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate teams, and tourist groups."
    },
    {
        question: "Can I get pickup from Terminal 2 and international arrivals?",
        answer: "Yes, airport pickups are available from international and domestic terminals according to passenger requirements."
    },
    {
        question: "Is airport taxi service available 24x7?",
        answer: "Yes, Mumbai Airport Cabs operates round the clock for airport pickups and drops."
    },
    {
        question: "How can I book a Taxi Service at Mumbai International Airport?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Arvind Sharma",
        feedback:
            "After a long international flight, the airport pickup was perfectly coordinated. The driver was waiting on time and the transfer was extremely comfortable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Poonam Mehta",
        feedback:
            "Mumbai Airport Cabs provided exceptional airport transportation for our family. The vehicle was spacious, the service was professional, and the entire experience was stress-free.",
        rating: 5
    }
];










































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Taxi Service at Mumbai International Airport",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-international-airport-taxi.jpg",
"description": "Book taxi service at Mumbai International Airport for safe and reliable airport pickup and drop. Mumbai Airport Cabs offers 24x7 cab service from T1 and T2 terminals with professional drivers, clean vehicles, and affordable fixed fares for local and outstation travel.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/taxi-service-at-mumbai-international-airport"
}
};








    return (
        <div>



<Helmet>
  <title>Mumbai International Airport Taxi Service | Pickup & Drop | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai International Airport taxi service for T1 and T2 terminals. 24x7 airport pickup and drop cab service with reliable drivers, clean cars, and affordable fares."
/>

<meta
 name="keywords"
 content="taxi service at mumbai international airport, mumbai airport taxi service, mumbai international airport cab service, airport pickup mumbai cab, airport drop mumbai taxi, mumbai t2 airport cab service, mumbai domestic airport taxi service, mumbai international airport taxi"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Taxiserviceatmumbaiinternatinal;